<template>
  <div class="modal" v-bind:class="{ 'is-active': show }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Detalle</p>
        <button
          class="button"
          style="margin-right: 2px"
          :class="monthclass(1)"
          @click="selectmonth(1)"
        >
          Ene
        </button>
        <button
          class="button"
          style="margin-right: 2px"
          :class="monthclass(2)"
          @click="selectmonth(2)"
        >
          Feb
        </button>
        <button
          class="button"
          style="margin-right: 2px"
          :class="monthclass(3)"
          @click="selectmonth(3)"
        >
          Mzo
        </button>
        <button
          class="button"
          style="margin-right: 2px"
          :class="monthclass(4)"
          @click="selectmonth(4)"
        >
          Abr
        </button>
        <button
          class="button"
          style="margin-right: 2px"
          :class="monthclass(5)"
          @click="selectmonth(5)"
        >
          Myo
        </button>
        <button
          class="button"
          style="margin-right: 2px"
          :class="monthclass(6)"
          @click="selectmonth(6)"
        >
          Jun
        </button>
        <button
          class="button"
          style="margin-right: 2px"
          :class="monthclass(7)"
          @click="selectmonth(7)"
        >
          Jul
        </button>
        <button
          class="button"
          style="margin-right: 2px"
          :class="monthclass(8)"
          @click="selectmonth(8)"
        >
          Ago
        </button>
        <button
          class="button"
          style="margin-right: 2px"
          :class="monthclass(9)"
          @click="selectmonth(9)"
        >
          Sep
        </button>
        <button
          class="button"
          style="margin-right: 2px"
          :class="monthclass(10)"
          @click="selectmonth(10)"
        >
          Oct
        </button>
        <button
          class="button"
          style="margin-right: 2px"
          :class="monthclass(11)"
          @click="selectmonth(11)"
        >
          Nov
        </button>
        <button
          class="button"
          style="margin-right: 2px"
          :class="monthclass(12)"
          @click="selectmonth(12)"
        >
          Dic
        </button>
        <button
          class="button"
          style="margin-right: 10px"
          :class="monthclass(13)"
          @click="selectmonth(13)"
        >
          Cie
        </button>
        <button class="delete" aria-label="close" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <div id="printdetalle" class="table-container">
          <strong>{{ empresa.nombre }}</strong>
          <small
            >{{ empresa.nit | textnumber() }}{{ empresa.nit | dverif() }}</small
          >
          <br />
          <strong>
            Detalle por tercero de la cuenta
            <span class="fontMono">{{ cuentaselected.codigo }}</span>
            {{ cuentaselected.nombre }}
          </strong>
          - {{ periodo | periodo() }}
          <table style="width: 100%; font-size: 14px" class="fontMono">
            <tr style="background-color: #f3f3f3">
              <td
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                "
              >
                <strong>Nit</strong>
              </td>
              <td
                v-if="cuentaselected.dctoref"
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                "
              >
                <strong>Mes</strong>
              </td>
              <td
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                "
              >
                <strong>D. Ref</strong>
              </td>
              <td
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                <strong>S Inicial</strong>
              </td>
              <td
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                <strong>Debito</strong>
              </td>
              <td
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                <strong>Credito</strong>
              </td>
              <td
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                <strong>S Final</strong>
              </td>
            </tr>
            <tr v-for="(item, index) in saldoaux.list" :key="index">
              <td style="padding: 2px" :style="styleTr(item)">
                <span
                  v-show="
                    saldoaux.objectnits[saldoaux[item].idnit].nombre !== 'NA'
                  "
                  >{{ saldoaux.objectnits[saldoaux[item].idnit].nombre }}
                  {{
                    saldoaux.objectnits[saldoaux[item].idnit].codigo
                      | textnumber()
                  }}{{
                    saldoaux.objectnits[saldoaux[item].idnit].codigo | dverif()
                  }}</span
                >
              </td>
              <td
                v-if="cuentaselected.dctoref"
                style="padding: 2px"
                :style="styleTr(item)"
              >
                {{ nmes(saldoaux[item].mes) }}
              </td>
              <td style="padding: 2px" :style="styleTr(item)">
                {{ saldoaux[item].docRef }}
              </td>
              <td
                style="padding: 2px 2px 2px 8px; text-align: right"
                :style="styleTr(item)"
              >
                {{ saldoaux[item].sinicial | number(2) }}
              </td>
              <td
                style="padding: 2px 2px 2px 8px; text-align: right"
                :style="styleTr(item)"
              >
                {{ saldoaux[item].debito | number(2) }}
              </td>
              <td
                style="padding: 2px 2px 2px 8px; text-align: right"
                :style="styleTr(item)"
              >
                {{ saldoaux[item].credito | number(2) }}
              </td>
              <td
                style="padding: 2px 2px 2px 8px; text-align: right"
                :style="styleTr(item)"
              >
                {{ saldoaux[item].sfinal | number(2) }}
              </td>
            </tr>
            <tr style="background-color: #f3f3f3">
              <td
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                "
              >
                <strong>TOTAL</strong>
              </td>
              <td
                v-if="cuentaselected.dctoref"
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                "
              >
                <strong></strong>
              </td>
              <td
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                "
              >
                <strong></strong>
              </td>
              <td
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                <strong>{{ saldoaux.total.sinicial | number(2) }}</strong>
              </td>
              <td
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                <strong>{{ saldoaux.total.debito | number(2) }}</strong>
              </td>
              <td
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                <strong>{{ saldoaux.total.credito | number(2) }}</strong>
              </td>
              <td
                style="
                  border-top: 1px solid #dbdbdb;
                  border-bottom: 1px solid #dbdbdb;
                  padding: 2px;
                  text-align: right;
                "
              >
                <strong>{{ saldoaux.total.sfinal | number(2) }}</strong>
              </td>
            </tr>
          </table>
        </div>
        <!-- Content ... -->
      </section>
      <footer class="modal-card-foot">
        <button class="button is-link" @click="imprimir">
          <span class="icon is-small">
            <span class="material-icons">print</span>
          </span>
          <span>Imprimir</span>
        </button>
        <button type="submit" class="button is-light" @click="descargarDetalle">
          <span class="icon is-small">
            <span class="material-icons">archive</span>
          </span>
          <span>Descargar</span>
        </button>
        <button class="button" @click="close">
          <span class="icon is-small">
            <span class="material-icons">cancel</span>
          </span>
          <span>Cancelar</span>
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
const XLSX = require("xlsx");
export default {
  props: {
    show: Boolean,
    saldoaux: Object,
    cuentaselected: Object,
    periodo: String,
    period: Object,
  },
  computed: {
    ...mapState(["empresa"]),
  },
  methods: {
    descargarDetalle() {
      const data2export = [];
      const indexCta = this.saldoaux.list.length;
      for (let item = 0; item < indexCta; item++) {
        const data2push = {
          Nit: `${
            this.saldoaux.objectnits[
              this.saldoaux[this.saldoaux.list[item]].idnit
            ].nombre
          } - ${
            this.saldoaux.objectnits[
              this.saldoaux[this.saldoaux.list[item]].idnit
            ].codigo
          }`,
          dref: this.saldoaux[this.saldoaux.list[item]].docRef,
          S_Inicial: this.saldoaux[this.saldoaux.list[item]].sinicial,
          Debito: this.saldoaux[this.saldoaux.list[item]].debito,
          Credito: this.saldoaux[this.saldoaux.list[item]].credito,
          S_Final: this.saldoaux[this.saldoaux.list[item]].sfinal,
        };
        data2export.push(data2push);
      }
      const data2pushTotal = {
        Nit: "TOTAL",
        dref: "",
        S_Inicial: this.saldoaux.total.sinicial,
        Debito: this.saldoaux.total.debito,
        Credito: this.saldoaux.total.credito,
        S_Final: this.saldoaux.total.sfinal,
      };
      data2export.push(data2pushTotal);
      let data = XLSX.utils.json_to_sheet(data2export);
      const workbook = XLSX.utils.book_new();
      const filename = "Balance de cuenta " + this.periodo;
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    imprimir() {
      // functions.imprimir(this.data.comprobante.nombre,this.data.documento,this.data.mes.codigo);
      this.$print("printdetalle", {
        name: `Detalle ${this.cuentaselected.codigo} ${this.cuentaselected.nombre} ${this.periodo}`,
      });
    },
    monthclass(month) {
      if (this.period.months.indexOf(month) !== -1) {
        return "is-primary";
      } else {
        return "";
      }
    },
    selectmonth(month) {
      const year = this.period.year;
      const months = [];
      months.push(month);
      this.$emit("selectperiod", { year, months });
    },
    nmes(dato) {
      let returned = "";
      if (dato) {
        const nmont = {
          99: "Ant",
          1: "Ene",
          2: "Feb",
          3: "Mzo",
          4: "Abr",
          5: "Myo",
          6: "Jun",
          7: "Jul",
          8: "Ago",
          9: "Sep",
          10: "Oct",
          11: "Nov",
          12: "Dic",
          13: "Cie",
        };
        for (let index = 0; index < dato.length; index++) {
          if (index === 0) {
            returned = nmont[dato[index]];
          } else {
            returned += `, ${nmont[dato[index]]}`;
          }
        }
      }

      return returned;
    },
    close() {
      this.$emit("showmodalsbalance", false);
    },
    styleTr(item) {
      if (this.saldoaux[item].isTotal) {
        return {
          "padding-bottom": "20px",
          "font-weight": "bold",
          "border-top": "1px solid #dbdbdb",
          color: "black",
        };
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/modals/SaldoModalBalance.vue